export default __webpack_public_path__ + "../ckeditor/plugins/tabletools/dialogs/tableCell.js";